import React, { createContext, useState, useEffect } from 'react';
import AuthService from '../../services/AuthService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const storedTime = localStorage.getItem('loginTimestamp');


        if (storedUser && storedTime) {
            const currentTime = new Date().getTime();
            const elapsedTime = currentTime - parseInt(storedTime, 10);

            if (elapsedTime > 86400000) {
                logout();
            } else {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
                console.log("Sessão carregada do localStorage:", parsedUser);
            }
        }
    }, []);

    

    const login = async (loginOrEmail, password) => {
        const userData = await AuthService.login(loginOrEmail, password);
        const loginTimestamp = Date.now();

        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('loginTimestamp', loginTimestamp.toString());
    };

    const logout = () => {
        AuthService.logout();
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('loginTimestamp');
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
